import Link from 'next/link';
import { Breadcrumb } from 'react-bootstrap';

type CustomBreadcrumbProps = {
  items: Array<{
    text: string;
    href?: string;
    active?: boolean;
  }>;
};

export default function CustomBreadcrumb({
  items = [],
}: CustomBreadcrumbProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <Breadcrumb className="py-2">
      {items.map((item) => {
        if (item.active) {
          return (
            <Breadcrumb.Item key={item.text} active>
              {item.text}
            </Breadcrumb.Item>
          );
        }

        return (
          <Link key={item.text} href={item.href} passHref legacyBehavior>
            <Breadcrumb.Item>{item.text}</Breadcrumb.Item>
          </Link>
        );
      })}
    </Breadcrumb>
  );
}
